export const RoadType = Object.freeze({
  MAIN: 'main',              // Principale
  SECONDARY: 'secondary',    // Secondaire
});